import React from 'react';
import PropTypes from 'prop-types';
import { Resource, DownloadLink } from '../../components';

const SimpleResources = ({ assetsDownloadLink }) =>
  <div className="col-sm-12">
    <h2 className="resource-headline">Monotone Logos</h2>
    <p className="resource-subheadline">
      Our monotone logos should be used only when no color printing our display is possible or when
      color is muted by design.
    </p>
    <div className="product-grid-3">
      <Resource
        src="https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-logo-monotone-black-f9bf0aaf29.svg"
        alt="Auth0 Logo Monotone Black"
        title="Monotone black"
      />
      <Resource
        inverted
        src="https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-logo-monotone-white-224bc3cf4c.svg"
        alt="Auth0 Logo Monotone White"
        title="Monotone white"
      />
    </div>
    <DownloadLink link={assetsDownloadLink} />
  </div>;

SimpleResources.propTypes = {
  assetsDownloadLink: PropTypes.string.isRequired
};

export default SimpleResources;



// WEBPACK FOOTER //
// ./src/pages/press/components/SimpleResources/SimpleResources.js